import {Injectable} from '@angular/core';
import * as _ from "lodash";

import {ControlService} from "./control.service";
import {
    CheckboxesMenuElement,
    CheckboxOption, MenuElementType112, MenuElementType15,
    OptionData, ParamsOption,
    SelectBoxOption
} from "../../models";
import {SendDataService} from "../send-data.service";
import {ParametersService} from "../parameters.service";
import {SubtitlesService} from "../subtitles.service";
import {AppAlertService} from "../app-alert.service";

@Injectable({
    providedIn: 'root'
})
export class InputBoxService {
    checkboxTable: CheckboxOption[] | ParamsOption[] = [];
    selectBoxTable: SelectBoxOption[] = [];
    selectChecked: number = 0;
    showWiki: boolean = false;

    constructor(
        private appAlert: AppAlertService,
        private control: ControlService,
        private parameters: ParametersService,
        private sendData: SendDataService,
        private subtitles: SubtitlesService,
    ) {
    }

    getCheckBox(): void {
        const elementVal = this.control.elementVal.getValue() as CheckboxesMenuElement;
        const table: CheckboxOption[] | ParamsOption[] = _.cloneDeep(elementVal.params.options);
        this.showWiki = false;

        table.forEach((val: CheckboxOption | ParamsOption) => {
            val.checked = val.value === elementVal.params.value;

            if (val['wikiTxtId'] > 0 || this.showWiki) this.showWiki = true;
        });

        this.checkboxTable = table;
    }

    setCheckBox(value: number): void {
        const elementVal = this.control.elementVal.getValue() as CheckboxesMenuElement;
        elementVal.params.value = value;
        this.control.elementVal.next(elementVal);

        this.checkboxTable = this.checkboxTable.map((val) => ({
            ...val,
            checked: val.value === value
        }));
    }

    returnExpandedCheckbox(elementVal: MenuElementType112): void {
        const dataToSend = {
            menuType: elementVal.menuType,
            ido: elementVal.id,
            data: {
                value: elementVal.params.value
            }
        }
        if (this.control.pin) {
            dataToSend.data['pin'] = this.control.pin
            this.control.pin = ''
        }

        this.sendData.sendControlData(dataToSend);

        if (!this.parameters.demoAccount()) {
            const element = this.control.element.getValue() as MenuElementType112;
            element.params.value = elementVal.params.value;
            element.duringChange = 't';
            this.control.element.next(element);
            this.control.setsNewValue = element.id;
        }

        const value = elementVal.params.options.find(
            (item: CheckboxOption) => item.value === elementVal.params.value
        );

        const message = '<div class="text-align-center">'
            + this.subtitles.setSubtitle(value.messageTxtId) + '</div>';

        if (value.messageTxtId > 0) {
            this.appAlert.showAppAlert(message, this.subtitles.setSubtitle(475),
                this.control.hideControl.bind(this.control), false, null);
        } else {
            this.control.hideControl();
        }
    }

    getSelectBox(value: number): void {
        this.selectChecked = value;
        const table: SelectBoxOption[] = [];
        const elementVal = this.control.elementVal.getValue() as MenuElementType15;
        elementVal.params.options.forEach((val: number, key: number) => {
            table[key] = {
                binary: (1 << key),
                name: val,
                checked: (value & (1 << key)) > 0
            }
        });

        this.selectBoxTable = table;
    }

    setSelectBox(value: number): void {
        let isSelected = 0;

        isSelected = this.selectBoxTable[value].checked
            ? (isSelected | (1 << value))
            : (isSelected & ~(1 << value));

        if (isSelected) {
            this.selectChecked += isSelected
        } else {
            this.selectChecked -= (1 << value)
        }
    }

    changeSelectedOptionsToInt(optionsData: OptionData[]): number  {
        return parseInt(optionsData.map(data => data.value).reverse().join(""),2);
    }

    returnSelectedBox(): void {
        const optionsData: OptionData[] = [];

        for (const key in this.selectBoxTable) {
            const option: OptionData = {
                id: parseInt(key),
                value: this.selectBoxTable[key].checked ? 1 : 0
            }
            optionsData.push(option);
        }

        this.selectChecked = this.changeSelectedOptionsToInt(optionsData);

        const dataToSend = {
            menuType: this.control.elementVal.getValue()?.menuType,
            ido: this.control.elementVal.getValue()?.id,
            data: {
                many_of_many: optionsData,
            }
        }
        if (this.control.pin) {
            dataToSend.data['pin'] = this.control.pin
            this.control.pin = ''
        }

        this.sendData.sendControlData(dataToSend);

        if (!this.parameters.demoAccount()) {
            const element = this.control.element.getValue() as MenuElementType15;
            element.params.value = this.selectChecked;
            element.duringChange = 't';
            this.control.element.next(element);

            const elementVal = this.control.elementVal.getValue()  as MenuElementType15;
            elementVal.params.value = this.selectChecked;
            this.control.elementVal.next(elementVal);

            this.control.setsNewValue = this.control.elementVal.getValue().id;
            this.control.hideControl();
        }
    }
}
